import React from "react";
import HalfYearDropDown from "./HalfYearDropDown";
import QaRoleSwitcher from "./QaRoleSwitcher";
import CurrentDate from "./HeaderDate";
import HeaderYear from "./HeaderYear";
import Navigation from "./HeaderNavigation";
import Title from "./HeaderTitle";

const Header = (props) => {
  return (
    <div className="main-header select-off">
      <div className="header-content">
        <Title {...props} />
        <Navigation {...props} />
        <QaRoleSwitcher />
        <HalfYearDropDown />
        <HeaderYear />
        <CurrentDate />
      </div>
    </div>
  );
};

export default Header;
